
























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import BundleDiscountPillBadge from './BundleDiscountPillBadge.vue'

@Component({
  components: {
    BundleDiscountPillBadge,
  },
})
export default class BundleDiscountPillWithTitle extends Vue {
  @Prop({ required: true })
  labelColor: string

  /**
   * 空文字もあり得る（タイトル未設定）
   */
  @Prop({ required: true })
  title: string

  /**
   * - default: large のピル「まとめて割引」の横にタイトルを添え、折り返して全文を出す
   * - cart: medium のピル「まとめて割引対象」の横にタイトルを 1 行で添え、末尾を…で省略する
   * - hl-cart: HOTEL LOVERS 系のカート. medium のピルの中に「タイトル + 対象」を入れ、タイトル側だけを…で省略する
   */
  @Prop({
    default: 'default',
    validator: (value: string) => value === 'default' || value === 'cart' || value === 'hl-cart',
  })
  mode: 'default' | 'cart' | 'hl-cart'

  get isForCart(): boolean {
    return this.mode !== 'default'
  }

  get showsTitleInPill(): boolean {
    return this.mode === 'hl-cart' && this.title !== ''
  }

  get showsTitleBeside(): boolean {
    return this.mode !== 'hl-cart' && this.title !== ''
  }
}
